import {Location} from 'react-router-dom';

// Navigation state recording where the user came from, so destination pages
// (e.g. ProjectPage) can offer a back button to the originating list/feed
// instead of home. Usage: navigate(url, fromLocationState(location)).
export default function fromLocationState(location: Location) {
    return {state: {from: location.pathname + location.search}};
}
